import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import 'react-dom';
import './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import './chunk-27cf4a5a.js';
import './chunk-23007274.js';
var Backdrop = styled(Hidden).withConfig({
  displayName: "Backdrop",
  componentId: "sc-1mc2k5c-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;z-index:998;-webkit-tap-highlight-color:rgba(0,0,0,0);-moz-tap-highlight-color:rgba(0,0,0,0);", ";"], theme("Backdrop"));
Backdrop.defaultProps = {
  role: "button",
  tabIndex: -1,
  opaque: true,
  palette: "shadow",
  tone: 2
};
var Backdrop$1 = as("div")(Backdrop);
export default Backdrop$1;